import React from 'react';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

const PeopleDirectory = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PeopleDirectory" */ '@confluence/people-directory/entry-points/PeopleDirectory.ts'
			)
		).PeopleDirectory,
});

export const PeopleDirectoryRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			name: string;
			attributes: {
				navdexPointType: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <PeopleDirectory />;

PeopleDirectoryRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		name: string;
		attributes: {
			navdexPointType: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	return {
		Screen: {
			name: 'inProdPeopleDirectory',
			attributes: {
				navdexPointType: START_TOUCH,
			},
		},
		MainLayout: { navView: PRODUCT_HOME_ID },
	};
};
